export class Endpoint {
    get host() {
        return 'https://szoter.com/';
    }
    get base() {
        return '/editor';
    }
    downloadProxy() {
        return '/api/image/proxy';
    }
    publish() {
        return '/api/project';
        // return `${this.base}publish2.php`;
    }
    feedback() {
        return `${this.base}feedback.php`;
    }
    static get shared() {
        return new Endpoint();
    }
}
